<template>
  <v-multiselect
    v-model="fieldModelValue"
    label="name"
    track-by="id"
    :options="options"
    :disabled="!editable"
    :allow-empty="false" />
</template>
<script>
export default {
  name: 'ProductTypeInput',
  props: {
    value: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  data() {
    return {
      options: []
    };
  },
  beforeCreate() {
    this.axios.get('/admin/producttypes')
      .then((res) => {
        this.options = res.data.result;
        [this.fieldModelValue] = this.options;
      });
  },
  computed: {
    fieldModelValue: {
      get() {
        if (!this.value) this.$emit('input', 0);
        return (
          this.options.filter((x) => x.id === this.value)
          || this.options.filter((x) => x.id === 0)
        );
      },
      set(newValue) {
        this.$emit('input', newValue.id);
      }
    }
  },
  methods: {
    setProductType(val) {
      this.fieldModelValue = this.options.find((x) => x.id === val);
    }
  }
};
</script>
<style lang="scss" scoped></style>
